$.fn.extend({
  getValidationGroup: function() {
    var elem = $(this);
    return elem.hasClass('validation-group') ? elem : elem.parent('.validation-group');
  },
  setConflict: function() {
    var validationGroup = this.getValidationGroup();
    validationGroup.removeClass('invalid');
    validationGroup.removeClass('required');
    validationGroup.addClass('conflict');
  },
  setInvalid: function() {
    var validationGroup = this.getValidationGroup();
    validationGroup.removeClass('conflict');
    validationGroup.removeClass('required');
    validationGroup.addClass('invalid');
  },
  setRequired: function() {
    var validationGroup = this.getValidationGroup();
    validationGroup.removeClass('conflict');
    validationGroup.removeClass('invalid');
    validationGroup.addClass('required');
  },
  setValid: function() {
    var validationGroup = this.getValidationGroup();
    validationGroup.removeClass('conflict');
    validationGroup.removeClass('invalid');
    validationGroup.removeClass('required');
  }
});